:host {

    /**
     * Breadcrumb section custom properties
     *
     * @prop --tiBreadcrumbSection-separator-color: color for the separator between breadcrumb items (/). Defaults to $pl-text-color-secondary-contrast (#cccccc)
     */

    display: block;
    position: relative;
    box-sizing: border-box;

    *, *::before, *::after {
        box-sizing: inherit;
    }

    .ti-breadcrumb-section {
        position: relative;
        display: flex;
        white-space: nowrap;

        &__separator {
            align-self: flex-start;
            width: $polaris-space-6;
            line-height: 28px;
            text-align: center;
            color: var(--tiBreadcrumbSection-separator-color, #{$pl-text-color-secondary-contrast});
        }
    }

    .ti-breadcrumb-home-section {
        position: relative;
        display: flex;
    }

    .ti-breadcrumb-section-list {
        column-gap: 1.5rem;
        column-rule: none;
    }

    .ti-breadcrumb-home-section ::slotted(a), .ti-breadcrumb-section ::slotted(a), .ti-breadcrumb-section-trigger ::slotted(a) {
        display: inline-block;
        text-decoration: none;
        color: inherit !important;
        font-size: 14px;
        line-height: 28px;

        &:hover,
        &:focus {
            text-decoration: underline !important;
        }
    }

    .sc-ti-breadcrumb-section-s a,
    .ti-breadcrumb-section-list ::slotted(a) {
        display: block !important;
        padding: 0;
        white-space: nowrap;
        text-decoration: none;
        color: currentColor;
        font-size: 14px;
        line-height: 28px;

        &:hover,
        &:focus {
            text-decoration: underline !important;
        }
    }
}
